/**
 * Stub of the multi-store helper from the source inventorySales project.
 *
 * The school system has no concept of multiple physical stores — there's
 * one school. We expose the same API the payroll feature expects so its
 * imports compile, but we collapse every "store" call to a single
 * canonical entry. If you ever need real multi-campus / multi-branch
 * scoping later, swap this for a real implementation.
 */

const SINGLE_STORE = { id: 1, name: "School", subtitle: "" };

export function getStores() {
  return [SINGLE_STORE];
}

export function getCurrentStoreName() {
  return SINGLE_STORE.name;
}

export function setCurrentStoreName(_name) {
  // No-op — school system has only one store.
}

export function setStoreName(_id, _name) {
  // No-op — names aren't editable in the school system stub.
}
